import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=43867d36"
import script from "./Dispositivos.vue?vue&type=script&lang=ts"
export * from "./Dispositivos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports